import { c as _c } from "react/compiler-runtime";
import { Badge } from "@repo/ui/mantine";
import styles from "./FewSeatsRemainingBadge.module.css";
type FewSeatsRemainingBadgeProps = {
  label: string;
};

/**
 * Status badge for class instances with few remaining seats.
 */
export function FewSeatsRemainingBadge(t0) {
  const $ = _c(3);
  const {
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      root: styles.badge,
      label: styles.badgeLabel
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <Badge classNames={t1} variant="outline" size="lg" radius="none">{label}</Badge>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}